import {
  EvaluationAvailableToRelateProforma,
  EvaluationAvailableToRelateProformaResponse
} from '@module/evaluation/model/EvaluationAvailableToRelateProformaResponse';
import { EvaluationResponse } from '@module/evaluation/model/EvaluationResponse';
import { SaveEvaluationValuesForm } from '@module/evaluation/model/SaveEvaluationValuesForm';
import {
  addSelectedValueToLinkedPDAs,
  getSelectedPDAsIds
} from '../apiHelpers';
import { evaluationApi } from '../api';

export const proformaApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLinkedPDAs: build.query<
      EvaluationAvailableToRelateProforma,
      { evaluationId: number; relationIds: string[] }
    >({
      query: ({ evaluationId }) => ({
        url: `/${evaluationId}/load-available-to-relate-proformas`,
        method: 'GET'
      }),
      transformResponse: (
        response: EvaluationAvailableToRelateProformaResponse,
        meta,
        arg
      ) => addSelectedValueToLinkedPDAs(response, arg.relationIds)
    }),

    submitLinkedPDAs: build.mutation<
      EvaluationResponse,
      {
        evaluationFromData: Omit<SaveEvaluationValuesForm, 'relationIds'>;
        selectedLinkedPDAs: EvaluationAvailableToRelateProforma;
      }
    >({
      query: ({ evaluationFromData, selectedLinkedPDAs }) => {
        const saveEvaluationValuesForm: SaveEvaluationValuesForm = {
          id: evaluationFromData.id,
          currency: evaluationFromData.currency,
          rate: evaluationFromData.rate,
          rateEur: evaluationFromData.rateEur,
          terminalId: evaluationFromData.terminalId,
          berthId: evaluationFromData.berthId,
          invoiceNumber: evaluationFromData.invoiceNumber,
          invoiceDate: evaluationFromData.invoiceDate,
          relationIds: getSelectedPDAsIds(selectedLinkedPDAs),
          proformaGroupId: evaluationFromData.proformaGroupId ?? null
        };

        return {
          url: '/save-evaluation-values',
          data: saveEvaluationValuesForm,
          method: 'POST'
        };
      },
      invalidatesTags: (res, _, { evaluationFromData }) =>
        res
          ? [{ type: 'EVALUATION', id: evaluationFromData.id }]
          : ['EVALUATION']
    })
  }),
  overrideExisting: false
});

export const { useFetchLinkedPDAsQuery, useSubmitLinkedPDAsMutation } =
  proformaApi;
